import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './error.component';
import { ErrorRoute } from './models/error-constant.model';
import { ErrorModuleNotLicensed } from './pages/error-module-not-licensed/error-module-not-licensed.component';
import { ErrorPageNotFoundComponent } from './pages/error-page-not-found/error-page-not-found.component';
import { ErrorPaymentComponent } from './pages/error-payment/error-payment.component';

const routes: Routes = [
  {
    path: '',
    component: ErrorComponent,
    pathMatch: 'prefix',
    children: [
      {
        path: ErrorRoute.ModuleNotLicensed,
        component: ErrorModuleNotLicensed,
        pathMatch: 'full'
      },
      {
        path: ErrorRoute.NotFound,
        component: ErrorPageNotFoundComponent,
        pathMatch: 'full'
      },
      {
        path: ErrorRoute.Payment,
        component: ErrorPaymentComponent,
        pathMatch: 'full'
      },
      {
        // Redirect to ModuleNotLicensed (probably went from lazy module loading error)
        path: '**',
        redirectTo: ErrorRoute.ModuleNotLicensed,
        pathMatch: 'full'
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }
